import React from 'react';

/**
 * Modal de confirmación reutilizable. Reemplaza window.confirm:
 * en la plataforma nunca se usan diálogos nativos.
 * `tone` controla el color del icono y del botón ('danger' por defecto).
 */
export const ConfirmModal = ({
  title,
  message,
  confirmLabel = 'Eliminar',
  cancelLabel = 'Cancelar',
  tone = 'danger',
  onConfirm,
  onClose
}) => {
  const isDanger = tone === 'danger';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className={`modal-header-icon ${isDanger ? 'danger' : ''}`}>
            {isDanger ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
            )}
          </span>
          <div className="modal-header-text">
            <h3 className="modal-title">{title}</h3>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Cerrar">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
              strokeLinecap="round">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {message && (
          <div className="modal-body">
            <p className="confirm-modal-message">{message}</p>
          </div>
        )}

        <div className="modal-footer">
          <button className="modal-btn modal-btn-ghost" onClick={onClose}>{cancelLabel}</button>
          <button
            className={`modal-btn ${isDanger ? 'modal-btn-danger' : 'modal-btn-primary'}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
